import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { QuoteWizard } from "@/components/QuoteWizard";

const API_BASE = (api.defaults.baseURL || "").replace(/\/api$/, "");

export default function Calculator() {
  const { t } = useI18n();
  const [settings, setSettings] = useState(null);
  const params = new URLSearchParams(window.location.search);
  // ?embed=1 hides the header/footer chrome so the calculator drops cleanly into an iframe.
  const embed = params.get("embed") === "1";
  const campaign = params.get("utm_campaign") || params.get("ref") || "";

  useEffect(() => {
    api.get("/public/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  const logo = settings?.branding?.website_logo;

  return (
    <div className={`min-h-screen ${embed ? "bg-transparent" : "bg-stone-50"} text-stone-900`} data-testid="calculator-page">
      {!embed && (
        <header className="bg-white border-b border-stone-200">
          <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2" data-testid="calc-home-link">
              {logo
                ? <img src={`${API_BASE}${logo}`} alt="Rimpatrio24" className="h-8 w-auto object-contain" />
                : <span className="font-serif-display text-xl text-stone-900">Rimpatrio<span className="text-[#8a6d2f]">24</span></span>}
            </Link>
            <LanguageSwitcher />
          </div>
        </header>
      )}

      <main className={`mx-auto px-4 sm:px-6 ${embed ? "py-4 max-w-2xl" : "py-8 sm:py-12 max-w-2xl"}`}>
        {!embed && (
          <div className="text-center mb-6">
            <h1 className="font-serif-display text-3xl sm:text-4xl text-stone-900">{t("calc.title")}</h1>
            <p className="text-stone-500 mt-2 text-sm sm:text-base">{t("calc.subtitle")}</p>
          </div>
        )}
        {settings ? <QuoteWizard settings={settings} campaign={campaign} /> : (
          <div className="h-72 rounded-2xl bg-white border border-stone-200 animate-pulse" />
        )}
        {!embed && (
          <p className="text-center text-xs text-stone-400 mt-6">
            <Link to="/" className="hover:text-stone-600 underline" data-testid="calc-full-site">{t("calc.fullSite")}</Link>
          </p>
        )}
      </main>
    </div>
  );
}
